// types
import { ItemType } from 'ducks/merchantDucks/items/actions';

export const setItemType = (itemType: string) => {
  return itemType === ItemType.Package ? ItemType.Package : ItemType.Asset;
};
